import React from 'react'
import './AlertManager.css'
const AlertManager = (props) => {
	if (props.data.alerts.visibility && props.data.alerts.duration !== 'infinite') {
		setTimeout(() => {
			props.data.setAlerts({
				visibility: false,
			})
		}, props.data.alerts.duration)
	}
	return (
		<>
			{props.data.alerts.visibility ? (
				<section>
					<div className="AlertManager">{props.data.alerts.message}</div>
				</section>
			) : null}
		</>
	)
}
export default AlertManager
